import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router'
import { connect } from 'react-redux'

import styles from '../CreateAction/ViewActions.module.css'
import renderPrgImage from '../../../source/programImg'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import MainHeader from '../../ReusableComponents/Header/MainHeader'
import VisualPrgm from '../../ReusableComponents/PrgmSlider/VisualPrgm/VisualPrgm'
import PrgmSelection from '../../ReusableComponents/PrgmSlider/PrgmSelection/PrgmSelection'
import ZingPrgmSelection from '../../ReusableComponents/PrgmSlider/ZingPrgmSelection/ZingPrgmSelection'
import PortConnections from '../../Assembly/PortConnections'
import components from '../../concept/data'
import { retrieveAssemblyData } from '../../../utils/retrieveData'
import cacheAssets from '../../../utils/cacheAssets'
import renderCompImg from '../../../source/Comp_Img'
import renderImage from '../../../source/importImg'
import ViewActions from '../CreateAction/ViewActions'
import { languageWords } from '../../../utils/langaugeSupport'
import { Message } from '@material-ui/icons'
import ShowAction from '../YourActions/ShowAction'
import { showModal } from '../../../redux/actions'
import {
    getDeviceNameWithVersion,
    stopByteCondition,
} from '../../../utils/utils'
import { useIndexedDB } from 'react-indexed-db'

const getUrl = {
    PeeCeeAlpha: '/selectScreen/InternalAccessories',
    PeeCeeBeta: '/v1/selectScreen/InternalAccessories',
    Hexapod: '/code/InternalAccessories',
    Humanoid: '/code/InternalAccessories',
    // Klaw: '/selectScreen/ExternalAccessories',
    Klaw: '/code/InternalAccessories',
    Roboki: '/v1/selectScreen/InternalAccessories',
    Atr: '/v1/selectScreen/InternalAccessories',
    Toki: '/v1/selectScreen/InternalAccessories',
    Poki: '/v1/selectScreen/InternalAccessories',
    Moki: '/v1/selectScreen/InternalAccessories',
    woofKit: '/v1/selectScreen/InternalAccessories',
}
let deviceVersion = sessionStorage.getItem('deviceVersion') || ''

// const getUrl = () => {
//     const version = sessionStorage.getItem('deviceVersion')
//     if (version?.startsWith('1')) {
//         return '/v1/selectScreen/InternalAccessories'
//     } else {
//         return '/selectScreen/InternalAccessories'
//     }
// }

// let ACE_MENU_OPTIONS = [
//     {
//         name: 'New Project',
//         imgSrc: 'newfilegroupbutton',
//         link: getUrl(),
//         imgStyle: { width: '19rem' },
//     },
//     {
//         name: 'Open Project',
//         imgSrc: 'yourprojectsgroupbutton',
//         link: '/comingSoon',
//         imgStyle: { width: '19rem' },
//     },
// ]

// const HUMANOID_MENU_OPTIONS = [
//     {
//         name: 'New Project',
//         imgSrc: 'newfilegroupbutton',
//         link: '/code/InternalAccessories',
//         imgStyle: { width: '19rem' },
//     },
//     {
//         name: 'Open Project',
//         imgSrc: 'yourprojectsgroupbutton',
//         link: '/comingSoon',
//         imgStyle: { width: '19rem' },
//     },
//     {
//         name: 'New Action',
//         imgSrc: 'newactiongroupbutton',
//         link: '/code/project/action/select',
//         imgStyle: {
//             width: '19rem',

//             marginTop: '20px',
//             scale: '1.05',
//         },
//     },
//     {
//         name: 'Open Action',
//         imgSrc: 'youractiongroupbutton',
//         link: '/code/project/actions',
//         imgStyle: {
//             width: '19rem',
//             marginTop: '20px',
//             scale: '1.05',
//         },
//     },
// ]

const container = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '22rem',
    width: '100vw',
    // paddingTop: '180px',
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
}

const menuText = {
    // position: 'relative',
    position: 'absolute',
    // top: '-8.5rem',
    top: '10.5rem',
    left: '6rem',
    fontSize: '1.3rem',
    cursor: 'pointer',
    width: '50%',
}

function Project(props) {
    const connectedDevice = sessionStorage.getItem('connectedDevice') || 'Ace'
    const version = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const [isShowApplicationLoader, setIsShowApplicationLoader] =
        useState(false)

    const DEVICE_MENU_OPTIONS = {
        Ace: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: getUrl[
                    deviceVersion.startsWith('1') ? 'PeeCeeBeta' : 'PeeCeeAlpha'
                ],
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
        ],

        Hexapod: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: '/code/InternalAccessories',
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
            {
                name: 'NewAction',
                imgSrc: 'newactiongroupbutton',
                link: ['2', '3'].includes(version?.[0])
                    ? '/code/selectActionType'
                    : // ? '/code/project/action/create'
                      '/code/project/action/select',
                imgStyle: {
                    width: '19rem',
                    marginTop: '20px',
                    scale: '1.05',
                },
            },
            {
                name: 'OpenAction',
                imgSrc: 'youractiongroupbutton',
                link: '/code/project/actions',
                imgStyle: {
                    width: '19rem',
                    marginTop: '20px',
                    scale: '1.05',
                },
            },
        ],
        Humanoid: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: '/code/InternalAccessories',
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
            {
                name: 'NewAction',
                imgSrc: 'newactiongroupbutton',
                link: version.startsWith('2')
                    ? '/code/selectActionType'
                    : // ? '/code/project/action/create'
                      '/code/project/action/select',
                imgStyle: {
                    width: '19rem',

                    marginTop: '20px',
                    scale: '1.05',
                },
            },
            {
                name: 'OpenAction',
                imgSrc: 'youractiongroupbutton',
                link: '/code/project/actions',
                imgStyle: {
                    width: '19rem',
                    marginTop: '20px',
                    scale: '1.05',
                },
            },
        ],
        Klaw: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: '/code/InternalAccessories',
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
            // {
            //     name: 'New Action',
            //     imgSrc: 'newactiongroupbutton',
            //     link: '/code/project/action/select',
            //     imgStyle: {
            //         width: '19rem',

            //         marginTop: '20px',
            //         scale: '1.05',
            //     },
            // },
            // {
            //     name: 'Open Action',
            //     imgSrc: 'youractiongroupbutton',
            //     link: '/code/project/actions',
            //     imgStyle: {
            //         width: '19rem',
            //         marginTop: '20px',
            //         scale: '1.05',
            //     },
            // },
        ],
        Roboki: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: getUrl['Roboki'],
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
        ],
        Atr: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: getUrl['Atr'],
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
        ],
        Toki: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: getUrl['Toki'],
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
        ],
        Poki: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: getUrl['Poki'],
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
        ],
        Moki: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: getUrl['Moki'],
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
        ],
        woofKit: [
            {
                name: 'NewProject',
                imgSrc: 'newfilegroupbutton',
                link: getUrl['woofKit'],
                imgStyle: { width: '19rem' },
            },
            {
                name: 'OpenProject',
                imgSrc: 'yourprojectsgroupbutton',
                link: '/comingSoon',
                imgStyle: { width: '19rem' },
            },
        ],
    }

    const history = useHistory()
    const { add, clear } = useIndexedDB('AudioFiles')
    let programMode = sessionStorage.getItem('programMode')
    const [isRecoverData, setIsRecoverData] = useState({
        recoveryDataPresent: false,
        link: '/code/project/',
    })
    const [isRetrieveData, setRetrieveData] = useState(false)
    const [isCondProps, setCondProps] = useState({})
    const [isText, setText] = useState('')
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const [showActionModal, setShowActionModal] = useState({
        isShow: false,
        Message: '',
        messageType: '',
    })
    const [retrieveActions, setRetrieveActions] = useState(false)

    let MENU_OPTIONS = false
    if (
        [
            'Ace',
            'Humanoid',
            'Hexapod',
            'Roboki',
            'Klaw',
            'Toki',
            'Poki',
            'Atr',
            'Moki',
            'woofKit',
        ].includes(connectedDevice)
    ) {
        MENU_OPTIONS = DEVICE_MENU_OPTIONS[connectedDevice]
    } else {
        MENU_OPTIONS = DEVICE_MENU_OPTIONS['Ace']
    }
    // useEffect(() => {
    //     ACE_MENU_OPTIONS = [
    //         {
    //             name: 'New Project',
    //             imgSrc: 'newfilegroupbutton',
    //             link: getUrl(),
    //             imgStyle: { width: '19rem' },
    //         },
    //         {
    //             name: 'Open Project',
    //             imgSrc: 'yourprojectsgroupbutton',
    //             link: '/comingSoon',
    //             imgStyle: { width: '19rem' },
    //         },
    //     ]
    // }, [props.device])
    useEffect(() => {
        var concept = { counter: [], componentProps: {} }
        var assembly = {
            components: components,
            PortConnections: PortConnections,
            workspace: {
                bibox: { top: 208, left: 328 },
                components: {},
                offset: { top: 0, left: 0 },
                scale: 1,
            },

            height: document.body.clientHeight,
            width: document.body.clientWidth,
        }
        var logic = {
            program: [
                {
                    type: 'start',
                    state: {
                        bic1: false,
                        bic2: false,
                        bic3: false,
                        bid2: false,
                        bif1: false,
                        bif2: false,
                        bif3: false,
                    },
                    bic1: false,
                    bic2: false,
                    bic3: false,
                    bid1: false,
                    bid2: false,
                    bif1: false,
                    bif2: false,
                    bif3: false,
                    bid3: false,
                    bmp3: false,
                },
            ],
            end: { type: 'end', state: 'repeat' },
            insertState: false,

            offset: { left: 0, top: 0 },
            scale: 1,
            currentProgramGuide: 0,
            active: [-1, -1],
            bottomPanel: 'border',
        }

        props.selecteComponent(concept)
        props.assemblyComponent(assembly)
        props.logicComponent(logic)

        sessionStorage.setItem('AppDetails', null)
        sessionStorage.removeItem('SelectedComp')
    }, [])

    useEffect(() => {
        if (isRecoverData.recoveryDataPresent === true) {
            let condProps = {
                show: isRecoverData.recoveryDataPresent,
                text: 'Would you like to recover your previous program?',
                optionsToSelect: [
                    {
                        text: 'YES',
                        do: async () => {
                            retriveRecoveryData(isRecoverData.link)
                            history.push(
                                isRecoverData.link
                                // getUrl[
                                //     connectedDevice == 'Ace'
                                //         ? deviceVersion.startsWith('1')
                                //             ? 'PeeCeeBeta'
                                //             : 'PeeCeeAlpha'
                                //         : connectedDevice
                                // ]
                            )
                            // enableExtensionsPort()
                            // setTimeout(() => {
                            //     if (
                            //         isRecoverData.link ===
                            //         '/code/selectActionType'
                            //         // '/code/project/action/create'
                            //     ) {
                            //         sendTorque0()
                            //     }
                            // }, 100)
                        },
                    },
                    {
                        text: 'NO',
                        do: () => {
                            history.push(
                                isRecoverData.link
                                // getUrl[
                                //     connectedDevice == 'Ace'
                                //         ? deviceVersion.startsWith('1')
                                //             ? 'PeeCeeBeta'
                                //             : 'PeeCeeAlpha'
                                //         : connectedDevice
                                // ]
                            )
                            sessionStorage.removeItem('PET')
                            sessionStorage.removeItem('SelectedStatus')
                            sessionStorage.removeItem('EndSwitch')
                            // enableExtensionsPort()
                            // setTimeout(() => {
                            //     if (
                            //         isRecoverData.link ===
                            //         '/code/selectActionType'
                            //         // '/code/project/action/create'
                            //     ) {
                            //         sendTorque0()
                            //     }
                            // }, 100)
                        },
                    },
                ],
            }
            console.log(condProps)
            setCondProps(condProps)
        }
        if (isRetrieveData === true) {
            let condProps = {
                show: isRetrieveData,
                text: isText,
                handleDialogModalClose: closeModal,
                showCloseBtn: true,
            }
            setCondProps(condProps)
        }
        if (
            isRecoverData.recoveryDataPresent === false &&
            isRetrieveData === false
        ) {
            let condProps = {
                show: false,
            }
            setCondProps(condProps)
        }
    }, [isRecoverData, isRetrieveData])

    //send stop bytes to stop the running programming
    const sendStopBytesDevice = (name) => {
        if (
            props.webSerial.isConnected &&
            ['NewAction', 'OpenAction'].includes(name)
        ) {
            let sendStopBytes = stopByteCondition({
                connectedDevice,
                deviceVersion,
            })
            props.worker.postMessage({
                type: 'writeArray',
                value: sendStopBytes,
            })
        }
    }

    // const sendTorque0 = () => {
    //     if (props.webSerial.isConnected) {
    //         props.worker.postMessage({
    //             type: 'writeArray',
    //             value: ['S'.charCodeAt(0), 'R'.charCodeAt(0), 0],
    //         })
    //     }
    // }
    // const enableExtensionsPort = () => {
    //     window.postMessage({ type: 'connect', data: 'connect' }, '*')
    // }

    const handleNewProject = async (option) => {
        let link = option.link
        sessionStorage.setItem('isSave', JSON.stringify(true))
        let recoveryData = JSON.parse(localStorage.getItem('recoveryData'))

        if (
            link === '/code/project/action/select' ||
            link === '/code/project/action/create' ||
            link === '/code/selectActionType'
        ) {
            // console.log('GGGGGGGg')
            programMode = 'actionBase'
        }

        if (
            localStorage.getItem('recoveryData') &&
            programMode in recoveryData &&
            connectedDevice in recoveryData[programMode] &&
            version in recoveryData[programMode][connectedDevice]
        ) {
            setIsRecoverData({ recoveryDataPresent: true, link: link })
        } else {
            history.push(link)
            if (link === '/code/selectActionType') {
                await clear()
                // enableExtensionsPort()
                // setTimeout(() => {
                //     sendTorque0()
                // }, 100)
            }
        }

        sendStopBytesDevice(option.name)
    }

    const retriveRecoveryData = (link) => {
        try {
            let recoveryData = JSON.parse(localStorage.getItem('recoveryData'))
            if (link === '/code/project/action/select') {
                let createActionState =
                    recoveryData['actionBase'][connectedDevice][version]
                        .createActionState
                sessionStorage.setItem(
                    'createActionState',
                    JSON.stringify(createActionState)
                )
            } else {
                recoveryData =
                    recoveryData[programMode][connectedDevice][version]

                for (let [key, value] of Object.entries(recoveryData)) {
                    sessionStorage.setItem(key, value)
                }
                props.selecteInternalAcessories(
                    JSON.parse(recoveryData.concept).internalaccessories
                )
                props.setZingMp3List(
                    JSON.parse(recoveryData?.concept)?.zingMp3List || []
                )
                props.selecteComponent(JSON.parse(recoveryData.concept))
                props.assemblyComponent(JSON.parse(recoveryData.assembly))
                props.logicComponent(JSON.parse(recoveryData.logic))
            }
        } catch (e) {
            localStorage.removeItem('recoveryData')
        }
    }

    //get the device name
    // const getDeviceName = (device, version) => {
    //     switch (device) {
    //         case 'Hexapod':
    //             return 'Crawl-e'
    //         case 'Humanoid':
    //             if (version?.[0] == '0') return 'Zing Alpha'
    //             else return 'Zing Beta'
    //         // case 'RB':
    //         //     return 'Roboki'
    //         case 'Klaw':
    //             return 'Klaw-b'
    //         case 'Ace':
    //             if (version?.[0] == '0') return 'PeeCee Alpha'
    //             else return 'PeeCee Beta'
    //         default:
    //             return device
    //     }
    // }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // const openProject = (event, loadContentType, followUpURL) => {
    //     sessionStorage.setItem('isSave', JSON.stringify(true))
    //     const connectedDevice = sessionStorage.getItem('connectedDevice')
    //     let file = event.target.files[0]
    //     const reader = new FileReader()
    //     reader.onload = (evt) => {
    //         const sessionData = JSON.parse(evt.target.result)
    //         const currDevice = sessionStorage.getItem('connectedDevice')
    //         const currMode = sessionStorage.getItem('programMode')
    //         const currVersion = sessionStorage.getItem('deviceVersion')

    //         let sessionDataVersion = ''
    //         if ('deviceVersion' in sessionData) {
    //             sessionDataVersion = sessionData.deviceVersion
    //         } else if ('PCVersion' in sessionData) {
    //             if (sessionData.PCVersion !== '0.0.0') {
    //                 sessionDataVersion = sessionData.PCVersion
    //             } else {
    //                 sessionDataVersion = sessionData.zingVersion
    //             }
    //         } else {
    //             sessionDataVersion = currVersion
    //         }

    //         if ('connectedDevice' in sessionData) {
    //             if (currDevice != sessionData.connectedDevice) {
    //                 setText(
    //                     `The Selected file is for ${getDeviceName(
    //                         sessionData.connectedDevice,
    //                         sessionDataVersion
    //                     )} not supported, please select the correct file.`
    //                 )
    //                 setRetrieveData(true)
    //                 event.target.value = ''
    //                 return
    //             }
    //         } else {
    //             setText(
    //                 `The Selected file is for different device, please select the correct file for ${currMode}.`
    //             )
    //             setRetrieveData(true)
    //             event.target.value = ''
    //             return
    //         }

    //         console.log(connectedDevice, loadContentType)
    //         sessionStorage.setItem('isSavedData', true)
    //         if (
    //             ['Roboki', 'Ace', 'Atr', 'Toki', 'Moki'].includes(
    //                 connectedDevice
    //             )
    //         ) {
    //             const currVersion = sessionStorage.getItem('deviceVersion')
    //             // const version = sessionStorage.getItem('deviceVersion') || null

    //             if (
    //                 currVersion.slice(0, 1) ===
    //                     sessionDataVersion.slice(0, 1) &&
    //                 currMode === sessionData.programMode
    //             ) {
    //                 sessionStorage.setItem('deviceVersion', sessionDataVersion)
    //                 Object.entries(sessionData).map((value) => {
    //                     if (retrieveAssemblyData.includes(value[0])) {
    //                         sessionStorage.setItem(value[0], value[1])
    //                         if (value[0] === 'concept') {
    //                             props.selecteComponent(JSON.parse(value[1]))
    //                             props.selecteInternalAcessories(
    //                                 JSON.parse(value[1]).internalaccessories
    //                             )
    //                         }
    //                         if (value[0] === 'assembly') {
    //                             props.assemblyComponent(JSON.parse(value[1]))
    //                         }
    //                         if (value[0] === 'logic') {
    //                             props.logicComponent(JSON.parse(value[1]))
    //                         }
    //                     }
    //                 })
    //                 // if (version !== null && version?.startsWith('1')) {
    //                 //     props.history.push(
    //                 //         '/v1/selectScreen/InternalAccessories'
    //                 //     )
    //                 // } else {
    //                 //     props.history.push('/selectScreen/InternalAccessories')
    //                 // }
    //                 if (
    //                     [
    //                         'Ace',
    //                         'Humanoid',
    //                         'Hexapod',
    //                         'Roboki',
    //                         'Toki',
    //                         'Klaw',
    //                         'Atr',
    //                         'Moki',
    //                     ].includes(connectedDevice)
    //                 ) {
    //                     history.push(
    //                         getUrl[
    //                             connectedDevice == 'Ace'
    //                                 ? deviceVersion.startsWith('1')
    //                                     ? 'PeeCeeBeta'
    //                                     : 'PeeCeeAlpha'
    //                                 : connectedDevice
    //                         ]
    //                     )
    //                 } else {
    //                     history.push(getUrl['PeeCeeAlpha'])
    //                 }
    //             } else {
    //                 setText(
    //                     `The Selected file is for a different version of ${getDeviceName(
    //                         sessionData.connectedDevice
    //                     )}, please select the correct file for ${currMode} for your ${getDeviceName(
    //                         sessionData.connectedDevice
    //                     )}`
    //                 )
    //                 setRetrieveData(true)
    //                 event.target.value = ''
    //             }
    //         } else if (
    //             ['Humanoid', 'Hexapod', 'Klaw'].includes(connectedDevice)
    //         ) {
    //             const currVersion = sessionStorage.getItem('deviceVersion')
    //             const currMode = sessionStorage.getItem('programMode')

    //             if (loadContentType === 'OpenAction') {
    //                 if (sessionData.connectedDevice != connectedDevice) {
    //                     setText(
    //                         `The Selected file is for ${getDeviceName(
    //                             sessionData.connectedDevice,
    //                             sessionDataVersion
    //                         )}, please select the correct file for ${getDeviceName(
    //                             connectedDevice,
    //                             currVersion
    //                         )} `
    //                     )
    //                     setRetrieveData(true)
    //                 }
    //                 //  else if (
    //                 //     currVersion.slice(0, 3) !==
    //                 //     sessionData.deviceVersion.slice(0, 3)
    //                 // ) {
    //                 //     setText(
    //                 //         `The Selected file is for a different version of ${getDeviceName(
    //                 //             connectedDevice,
    //                 //             sessionDataVersion
    //                 //         )}, please select the correct file for ${getDeviceName(
    //                 //             connectedDevice,
    //                 //             sessionDataVersion
    //                 //         )} `
    //                 //     )
    //                 //     setRetrieveData(true)
    //                 // }
    //                 else if (
    //                     (currVersion?.startsWith('0') ||
    //                         sessionDataVersion?.startsWith('0')) &&
    //                     currVersion?.[0] !== sessionDataVersion?.[0]
    //                 ) {
    //                     setText(
    //                         `The Selected file is for ${getDeviceName(
    //                             connectedDevice,
    //                             sessionDataVersion
    //                         )}, please select the correct file for ${getDeviceName(
    //                             connectedDevice,
    //                             currVersion
    //                         )} `
    //                     )
    //                     setRetrieveData(true)
    //                 } else {
    //                     Object.entries(sessionData).map((value) => {
    //                         if (value[0] === 'programMode') {
    //                             sessionStorage.setItem(value[0], 'projectBased')
    //                         } else {
    //                             sessionStorage.setItem(value[0], value[1])
    //                         }
    //                     })

    //                     if (deviceVersion?.startsWith('2')) {
    //                         history.push('/code/project/action/create')
    //                         setTimeout(() => {
    //                             sendTorque0()
    //                         }, 100)
    //                     } else {
    //                         history.push('/code/project/action/select')
    //                     }
    //                 }
    //             } else if (loadContentType === 'OpenProject') {
    //                 if (
    //                     currVersion.slice(0, 3) ===
    //                         sessionData.deviceVersion.slice(0, 3) &&
    //                     currMode === sessionData.programMode
    //                 ) {
    //                     //update redux
    //                     Object.entries(sessionData).map((value) => {
    //                         if (retrieveAssemblyData.includes(value[0])) {
    //                             sessionStorage.setItem(value[0], value[1])
    //                             if (value[0] === 'concept') {
    //                                 props.selecteComponent(JSON.parse(value[1]))
    //                                 props.selecteInternalAcessories(
    //                                     JSON.parse(value[1]).internalaccessories
    //                                 )
    //                                 props.setZingMp3List(
    //                                     JSON.parse(value[1])?.zingMp3List || []
    //                                 )
    //                             }
    //                             if (value[0] === 'assembly') {
    //                                 props.assemblyComponent(
    //                                     JSON.parse(value[1])
    //                                 )
    //                             }
    //                             if (value[0] === 'logic') {
    //                                 props.logicComponent(JSON.parse(value[1]))
    //                             }
    //                         }
    //                     })
    //                     history.push('/code/InternalAccessories')
    //                     window.location.reload()
    //                 } else {
    //                     setText(
    //                         `The Selected file is for a different version of ${getDeviceName(
    //                             sessionData.connectedDevice,
    //                             sessionDataVersion
    //                         )}, please select the correct file for ${currMode} for your ${getDeviceName(
    //                             sessionData.connectedDevice,
    //                             sessionDataVersion
    //                         )}`
    //                     )
    //                     setRetrieveData(true)
    //                     event.target.value = ''
    //                 }
    //             }
    //         }
    //     }
    //     reader.readAsText(file)
    // }

    // const handleFolderUpload = async (event, loadContentType, followUpURL) => {
    //     const uploadedFiles = Array.from(event.target.files)
    //     if (uploadedFiles.length === 0) return

    //     // Extract the folder name from the first file's path
    //     const fullPath =
    //         uploadedFiles[0].webkitRelativePath || uploadedFiles[0].name
    //     const extractedFolderName = fullPath.split('/')[0] // First part of the path is the folder name

    //     let audioFile = null
    //     let pldFile = null

    //     // Filter files that match the folder name and have the correct extensions
    //     const filteredFiles = uploadedFiles.filter((file) => {
    //         const fileName = file.name.split('.')[0] // Extract filename without extension
    //         return (
    //             fileName === extractedFolderName &&
    //             (file.name.endsWith('.mp3') || file.name.endsWith('.pld'))
    //         )
    //     })
    //     // Check if both required files exist
    //     const hasMP3 = filteredFiles.some((file) => file.name.endsWith('.mp3'))
    //     const hasPLD = filteredFiles.some((file) => file.name.endsWith('.pld'))

    //     if (!hasMP3 || !hasPLD) {
    //         setText(
    //             `The folder "${extractedFolderName}" must contain both an .mp3 and a .pld file with the same name.`
    //         )
    //         setRetrieveData(true)
    //         event.target.value = ''
    //         return
    //     }

    //     // const reader = new FileReader()
    //     const pldFileHandel = (evt) => {
    //         const sessionData = JSON.parse(evt.target.result)
    //         const currDevice = sessionStorage.getItem('connectedDevice')
    //         const currMode = sessionStorage.getItem('programMode')
    //         const currVersion = sessionStorage.getItem('deviceVersion')

    //         let sessionDataVersion = ''
    //         if ('deviceVersion' in sessionData) {
    //             sessionDataVersion = sessionData.deviceVersion
    //         } else if ('PCVersion' in sessionData) {
    //             if (sessionData.PCVersion !== '0.0.0') {
    //                 sessionDataVersion = sessionData.PCVersion
    //             } else {
    //                 sessionDataVersion = sessionData.zingVersion
    //             }
    //         } else {
    //             sessionDataVersion = currVersion
    //         }

    //         if ('connectedDevice' in sessionData) {
    //             if (currDevice != sessionData.connectedDevice) {
    //                 setText(
    //                     `The Selected folder is for ${getDeviceName(
    //                         sessionData.connectedDevice,
    //                         sessionDataVersion
    //                     )} not supported, please select the correct file.`
    //                 )
    //                 setRetrieveData(true)
    //                 event.target.value = ''
    //                 return { status: false }
    //             }
    //         } else {
    //             setText(
    //                 `The Selected file is for different device, please select the correct file for ${currMode}.`
    //             )
    //             setRetrieveData(true)
    //             event.target.value = ''
    //             return { status: false }
    //         }

    //         console.log(connectedDevice, loadContentType)
    //         sessionStorage.setItem('isSavedData', true)
    //         if (['Humanoid', 'Hexapod'].includes(connectedDevice)) {
    //             const currVersion = sessionStorage.getItem('deviceVersion')
    //             const currMode = sessionStorage.getItem('programMode')

    //             if (loadContentType === 'OpenAction') {
    //                 if (currVersion?.[0] !== sessionDataVersion?.[0]) {
    //                     setText(
    //                         `The Selected folder is for ${getDeviceName(
    //                             connectedDevice,
    //                             sessionDataVersion
    //                         )}, please select the correct folder for ${getDeviceName(
    //                             connectedDevice,
    //                             currVersion
    //                         )} `
    //                     )
    //                     setRetrieveData(true)
    //                 } else {
    //                     Object.entries(sessionData).map((value) => {
    //                         if (value[0] === 'programMode') {
    //                             sessionStorage.setItem(value[0], 'projectBased')
    //                         } else {
    //                             sessionStorage.setItem(value[0], value[1])
    //                         }
    //                     })

    //                     // history.push('/code/project/action/create')
    //                     // setTimeout(() => {
    //                     //     sendTorque0()
    //                     // }, 100)
    //                     return { status: true }
    //                 }
    //             } else {
    //                 setText(
    //                     `The Selected folder is for ${getDeviceName(
    //                         connectedDevice,
    //                         sessionDataVersion
    //                     )}, please select the correct folder for ${getDeviceName(
    //                         connectedDevice,
    //                         currVersion
    //                     )} `
    //                 )
    //                 setRetrieveData(true)
    //                 return { status: false }
    //             }
    //         }
    //         return { status: false }
    //     }
    //     // reader.readAsText(pldFile)
    //     let pldFileLoadStatus = false
    //     let mp3FileLoadStatus = false

    //     async function processFiles(files) {
    //         // Map each file to a promise that resolves when the file is processed
    //         const fileProcessingPromises = files.map((file) => {
    //             return new Promise((resolve, reject) => {
    //                 const reader = new FileReader()
    //                 reader.onload = async (e) => {
    //                     try {
    //                         if (file.name.endsWith('.pld')) {
    //                             const { status } = pldFileHandel(e)
    //                             pldFileLoadStatus = status
    //                         } else {
    //                             const fileData = e.target.result
    //                             try {
    //                                 const id = await add({
    //                                     fileName: file.name,
    //                                     fileData: fileData,
    //                                 })
    //                                 console.log('Audio file added with ID:', id)
    //                                 mp3FileLoadStatus = true
    //                             } catch (error) {
    //                                 console.error(error)
    //                             }
    //                         }
    //                         resolve() // Resolve the promise after processing
    //                     } catch (error) {
    //                         reject(error) // Reject the promise if an error occurs
    //                     }
    //                 }
    //                 if (file.name.endsWith('.pld')) {
    //                     reader.readAsText(file)
    //                 } else {
    //                     reader.readAsDataURL(file)
    //                 }
    //             })
    //         })

    //         // Wait for all file processing promises to complete
    //         await Promise.all(fileProcessingPromises)

    //         if (pldFileLoadStatus && mp3FileLoadStatus) {
    //             history.push('/code/project/action/create')
    //             setTimeout(() => {
    //                 sendTorque0()
    //             }, 100)
    //         }
    //     }

    //     await processFiles(filteredFiles).catch((error) => {
    //         console.error('Error processing files:', error)
    //     })
    // }

    const getSessionDataVersion = (sessionData) => {
        if ('deviceVersion' in sessionData) return sessionData.deviceVersion
        if ('PCVersion' in sessionData) {
            return sessionData.PCVersion !== '0.0.0'
                ? sessionData.PCVersion
                : sessionData.zingVersion
        }
        return sessionStorage.getItem('deviceVersion')
    }

    const validateDeviceCompatibility = (
        sessionData,
        currDevice,
        currMode,
        sessionDataVersion,
        event
    ) => {
        if (
            sessionData.connectedDevice &&
            currDevice !== sessionData.connectedDevice
        ) {
            setText(
                `The Selected file is for ${getDeviceNameWithVersion(
                    sessionData.connectedDevice,
                    sessionDataVersion
                )} and is not supported. Please select the correct file.`
            )
            setRetrieveData(true)
            event.target.value = ''
            return false
        }
        return true
    }

    const updateSessionStorage = async (sessionData, loadContentType) => {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        try {
            // Object.entries(sessionData).forEach(async ([key, value]) => {
            for (const [key, value] of Object.entries(sessionData)) {
                if (key === 'createActionMusic') {
                    await clear()
                    let data = await add({
                        fileName: 'audio.mp3',
                        fileData: value,
                    })
                    // console.log('VVVVVVVVVVV', data)
                } else {
                    if (loadContentType === 'OpenProject') {
                        if (retrieveAssemblyData.includes(key)) {
                            sessionStorage.setItem(
                                key,
                                key === 'programMode' ? 'projectBased' : value
                            )
                            if (key === 'concept') {
                                props.selecteComponent(JSON.parse(value))
                                props.selecteInternalAcessories(
                                    JSON.parse(value).internalaccessories
                                )

                                if (
                                    ['Humanoid', 'Hexapod', 'Klaw'].includes(
                                        connectedDevice
                                    )
                                ) {
                                    props.setZingMp3List(
                                        JSON.parse(value)?.zingMp3List || []
                                    )
                                }
                            }
                            if (key === 'assembly') {
                                props.assemblyComponent(JSON.parse(value))
                            }
                            if (key === 'logic') {
                                props.logicComponent(JSON.parse(value))
                            }
                        }
                    } else {
                        sessionStorage.setItem(
                            key,
                            key === 'programMode' ? 'projectBased' : value
                        )
                    }
                }
            }
        } catch (e) {
            console.log('Error', e)
        }
        // })
    }

    const openProject = (event, loadContentType) => {
        sessionStorage.setItem('isSave', JSON.stringify(true))
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        let file = event.target.files[0]
        const reader = new FileReader()

        reader.onload = (evt) => {
            const sessionData = JSON.parse(evt.target.result)
            const currDevice = sessionStorage.getItem('connectedDevice')
            const currMode = sessionStorage.getItem('programMode')
            const currVersion = sessionStorage.getItem('deviceVersion')
            const sessionDataVersion = getSessionDataVersion(sessionData)

            if (
                !validateDeviceCompatibility(
                    sessionData,
                    currDevice,
                    currMode,
                    sessionDataVersion,
                    event
                )
            )
                return

            sessionStorage.setItem('isSavedData', true)

            if (
                ['Roboki', 'Ace', 'Atr', 'Toki', 'Poki', 'Moki'].includes(
                    connectedDevice
                )
            ) {
                if (
                    currVersion.startsWith(sessionDataVersion[0]) &&
                    currMode === sessionData.programMode
                ) {
                    sessionStorage.setItem('deviceVersion', sessionDataVersion)
                    updateSessionStorage(sessionData, loadContentType)

                    history.push(
                        getUrl[
                            connectedDevice == 'Ace'
                                ? currVersion.startsWith('1')
                                    ? 'PeeCeeBeta'
                                    : 'PeeCeeAlpha'
                                : connectedDevice
                        ] || getUrl['PeeCeeAlpha']
                    )
                } else {
                    setText(
                        `The Selected file is for a different version of ${getDeviceNameWithVersion(
                            sessionData.connectedDevice,
                            sessionData.deviceVersion
                        )}, please select the correct file for ${currMode}.`
                    )
                    setRetrieveData(true)
                    event.target.value = ''
                }
            } else if (
                ['Humanoid', 'Hexapod', 'Klaw'].includes(connectedDevice)
            ) {
                handleHumanoidHexapodUpload(
                    sessionData,
                    connectedDevice,
                    currVersion,
                    currMode,
                    sessionDataVersion,
                    loadContentType,
                    event
                )
            }
        }
        reader.readAsText(file)
    }
    const checkPldFileIsNew = (sessionData) => {
        let createActionData = JSON.stringify(sessionData)
        if (createActionData) {
            if (createActionData.includes('markerPositionTime')) {
                return true
            }
        }
        return false
    }
    const handleHumanoidHexapodUpload = async (
        sessionData,
        connectedDevice,
        currVersion,
        currMode,
        sessionDataVersion,
        loadContentType,
        event
    ) => {
        if (loadContentType === 'OpenAction') {
            if (currVersion[0] !== sessionDataVersion[0]) {
                setText(
                    `The Selected file is for ${getDeviceNameWithVersion(
                        connectedDevice,
                        sessionDataVersion
                    )}, please select the correct file.`
                )
                setRetrieveData(true)
            } else {
                // await clear()
                await updateSessionStorage(sessionData)

                if (['2', '3'].includes(deviceVersion?.[0])) {
                    let isShowNewUI = checkPldFileIsNew(sessionData)
                    sessionStorage.setItem('isShowNewUI', isShowNewUI)
                    sessionStorage.setItem('actionFileOpen', 'true')
                }
                history.push(
                    ['2', '3'].includes(deviceVersion?.[0])
                        ? '/code/project/action/create'
                        : '/code/project/action/select'
                )
                // enableExtensionsPort()
                // setTimeout(() => sendTorque0(), 100)
            }
        } else if (loadContentType === 'OpenProject') {
            if (
                currVersion.startsWith(sessionData.deviceVersion.slice(0, 3)) &&
                currMode === sessionData.programMode
            ) {
                await updateSessionStorage(sessionData, loadContentType)
                history.push('/code/InternalAccessories')
                // window.location.reload()
            } else {
                setText(
                    `The Selected file is for a different version of ${getDeviceNameWithVersion(
                        sessionData.connectedDevice,
                        sessionData.deviceVersion
                    )}, please select the correct file.`
                )
                setRetrieveData(true)
                event.target.value = ''
            }
        }
    }

    const handleFolderUpload = async (event, loadContentType) => {
        const uploadedFiles = Array.from(event.target.files)
        if (uploadedFiles.length === 0) return

        const folderName = (
            uploadedFiles[0].webkitRelativePath || uploadedFiles[0].name
        ).split('/')[0]
        const filteredFiles = uploadedFiles.filter(
            (file) =>
                file.name.startsWith(folderName) &&
                /\.(mp3|pld)$/i.test(file.name)
        )

        if (
            !filteredFiles.some((file) => file.name.endsWith('.mp3')) ||
            !filteredFiles.some((file) => file.name.endsWith('.pld'))
        ) {
            setText(
                `The folder "${folderName}" must contain both an .mp3 and a .pld file.`
            )
            setRetrieveData(true)
            event.target.value = ''
            return
        }

        let pldFileLoaded = false
        let mp3FileLoaded = false

        await Promise.all(
            filteredFiles.map(
                (file) =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader()
                        reader.onload = async (e) => {
                            try {
                                if (file.name.endsWith('.pld')) {
                                    pldFileLoaded = processPldFile(e, event)
                                } else {
                                    try {
                                        await clear()
                                        await add({
                                            fileName: file.name,
                                            fileData: e.target.result,
                                        })
                                        mp3FileLoaded = true
                                    } catch (error) {
                                        console.error(error)
                                    }
                                }
                                resolve()
                            } catch (error) {
                                reject(error)
                            }
                        }
                        file.name.endsWith('.pld')
                            ? reader.readAsText(file)
                            : reader.readAsDataURL(file)
                    })
            )
        )

        if (pldFileLoaded && mp3FileLoaded) {
            history.push('/code/project/action/create')
            sessionStorage.setItem('actionFileOpen', 'true')
            // enableExtensionsPort()
            // setTimeout(() => sendTorque0(), 100)
        }
    }

    const processPldFile = (evt, event) => {
        const sessionData = JSON.parse(evt.target.result)
        const currDevice = sessionStorage.getItem('connectedDevice')
        const currMode = sessionStorage.getItem('programMode')
        const currVersion = sessionStorage.getItem('deviceVersion')
        const sessionDataVersion = getSessionDataVersion(sessionData)

        if (
            !validateDeviceCompatibility(
                sessionData,
                currDevice,
                currMode,
                sessionDataVersion,
                event
            )
        )
            return false

        sessionStorage.setItem('isSavedData', true)

        if (['Humanoid', 'Hexapod'].includes(currDevice)) {
            if (currVersion[0] !== sessionDataVersion[0]) {
                setText(
                    `The Selected folder is for ${getDeviceNameWithVersion(
                        currDevice,
                        sessionDataVersion
                    )}, please select the correct folder.`
                )
                setRetrieveData(true)
                return false
            } else {
                updateSessionStorage(sessionData)
                return true
            }
        }
        return false
    }

    // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const closeModal = () => {
        setRetrieveData(false)
        let condProps = {
            show: false,
        }
        setCondProps(condProps)
    }

    //in open the file, dialog model shows option generat
    const dialogModelOption = () => {
        let optionArr = []
        if (showActionModal.messageType === 'fileOpen') {
            // if (props.webSerial.isConnected) {
            optionArr.push({
                text: connectedDevice === 'Hexapod' ? 'crawl-e' : 'Zing',
                do: () => {
                    let spliTVersion = deviceVersion?.split('.')
                    //['2', '3'].includes(deviceVersion?.[0])
                    if (
                        ['Humanoid', 'Zing Beta'].includes(connectedDevice) &&
                        ((['2'].includes(spliTVersion?.[0]) &&
                            6 <= parseInt(spliTVersion?.[2] ?? '0')) ||
                            3 <= parseInt(spliTVersion?.[0] ?? '0'))
                    ) {
                        sessionStorage.setItem('isShowNewUI', 'true')
                    } else {
                        sessionStorage.setItem('isShowNewUI', 'false')
                    }
                    if (!props.webSerial.isConnected) {
                        setShowActionModal({
                            isShow: true,
                            Message: 'Please connect the device.',
                            messageType: '',
                        })
                    } else {
                        sendStopBytesDevice('OpenAction')
                        setShowActionModal({
                            isShow: false,
                            Message: '',
                            messageType: '',
                        })
                        setRetrieveActions(true)
                    }
                },
            })
            // }

            optionArr.push({
                text: 'Local',
                do: () => {
                    sendStopBytesDevice('OpenAction')
                    document.getElementById(`file-input-3`).click()
                    setShowActionModal({
                        isShow: false,
                        Message: '',
                        messageType: '',
                    })
                },
            })

            // if (deviceVersion?.startsWith('2')) {
            //     optionArr.push({
            //         text: 'Folder',
            //         do: () => {
            //             sendStopBytesDevice('OpenAction')
            //             document.getElementById(`folder-input-3`).click()
            //             setShowActionModal({
            //                 isShow: false,
            //                 Message: '',
            //                 messageType: '',
            //             })
            //         },
            //     })
            // }
        } else if (showActionModal.messageType === 'install') {
            optionArr.push({
                text: 'Plode Web Agent',
                do: async () => {
                    const { platform, architecture } =
                        await navigator.userAgentData.getHighEntropyValues([
                            'architecture',
                            'platform',
                        ])

                    const downloadLinks = {
                        macOS: {
                            x86: 'https://tools.plode.org/plode_web_agent.pkg',
                            arm: 'https://tools.plode.org/plode_web_agent.pkg',
                        },
                        Windows: 'https://tools.plode.org/plode_web_agent.exe',
                    }

                    const downloadLink =
                        platform === 'macOS'
                            ? downloadLinks.macOS[architecture]
                            : downloadLinks[platform]

                    if (downloadLink) {
                        window.open(downloadLink, '_blank')
                        setShowActionModal({
                            isShow: false,
                            Message: '',
                            messageType: '',
                        })
                    } else {
                        setShowActionModal({
                            isShow: true,
                            Message:
                                'The Plode Web Agent is not available for your current platform or system architecture. Please use Windows 10 or macOS to proceed.',
                            messageType: '',
                        })
                    }

                    console.log('User data:', { platform, architecture })
                },
            })

            optionArr.push({
                text: 'Enter',
                do: async () => {
                    try {
                        if (showActionModal.option.name === 'OpenAction') {
                            openFileHandel(
                                showActionModal.option,
                                showActionModal.index
                            )
                        } else {
                            handelNewFile(showActionModal.option)
                            setShowActionModal({
                                isShow: false,
                                Message: '',
                                messageType: '',
                            })
                        }
                    } catch (e) {
                        console.log(e)
                    }
                },
            })
        }
        return optionArr
    }
    const clearActionFromSession = () => {
        console.log('clearing action data')
        sessionStorage.removeItem('createActionState')
    }

    const showMemoryNotpresent = (option) => {
        if (
            connectedDevice === 'Hexapod' &&
            ['2', '3'].includes(deviceVersion?.[0]) &&
            !props.device.isMemoryPresent &&
            props.webSerial.isConnected &&
            ['OpenAction', 'NewAction'].includes(option.name)
        ) {
            setShowActionModal({
                isShow: true,
                Message: `There is no memory card inserted in ${getDeviceNameWithVersion(
                    connectedDevice,
                    deviceVersion
                )}. \nkindly insert one to use the application further.`,
                messageType: 'MemoryError',
            })
            return true
        }
        return false
    }

    const openFileHandel = (option, index) => {
        if (showMemoryNotpresent(option)) {
            return
        }

        if (
            ['Humanoid', 'Hexapod'].includes(connectedDevice) &&
            ['1', '2', '3'].includes(deviceVersion[0]) &&
            option.name == 'OpenAction'
        ) {
            setShowActionModal({
                isShow: true,
                Message: 'Open files from',
                messageType: 'fileOpen',
            })
            return
        }

        document.getElementById(`file-input-${index}`).click()
    }

    const handelNewFile = (option) => {
        if (showMemoryNotpresent(option)) {
            return
        }

        sessionStorage.removeItem('slideDirection')
        if (['NewProject', 'NewAction'].includes(option.name))
            handleNewProject(option)
        else history.push(option.link)
    }

    const checkSocketConnection = (option, index = 0) => {
        const noSocket = !props?.socketData?.socket?.connected
        const deviceMinVersion = {
            Humanoid: { major: 3 },
            Hexapod: { major: 3 },
            Klaw: { major: 1, patch: 3 }, // Klaw requires minor version too
        }
        const [majorStr = '0', minorStr = '0', patchStr = '0'] = (
            deviceVersion || '0.0.0'
        ).split('.')
        const majorVersion = parseInt(majorStr, 10)
        const patch = parseInt(patchStr, 10)
        const minVersion = deviceMinVersion[connectedDevice] || {
            major: Infinity,
            patch: Infinity,
        }

        const meetsVersionRequirement = () => {
            if (connectedDevice === 'Klaw') {
                if (majorVersion > minVersion.major) return true
                if (majorVersion < minVersion.major) return false
                return patch >= minVersion.patch
            }
            return majorVersion >= minVersion.major
        }

        if (
            noSocket &&
            (['OpenAction', 'NewAction'].includes(option.name) ||
                (['OpenProject', 'NewProject'].includes(option.name) &&
                    meetsVersionRequirement()))
        ) {
            setShowActionModal({
                isShow: true,
                Message: `To use this feature, please install the Plode Web Agent. You can download it from tools.plode.org.`,
                messageType: 'install',
                option: option,
                index: index,
            })
            return false
        }
        return true
    }

    const beforeOpenFileHandel = (option, index) => {
        if (checkSocketConnection(option, index)) openFileHandel(option, index)
    }
    const beforeHandelNewFile = (option) => {
        if (checkSocketConnection(option)) handelNewFile(option)
    }

    useEffect(() => {
        setIsShowApplicationLoader(true)
        let assetsToBeCached = [
            // helpScreen
            renderPrgImage('zingProjectH'),
            renderPrgImage('zingProjectH1'),
            renderPrgImage('zingProjectH2'),
            renderPrgImage('zingProjectH3'),
            renderPrgImage('zingProjectH4'),
            renderPrgImage('SelectionPrgf1'),
            renderPrgImage('SelectionPrgf2'),
            renderPrgImage('SelectionPrgf3'),

            // internal, external,assembly,login screen

            renderPrgImage('saveBtnActive'),
            renderPrgImage('usbOFF'),
            renderPrgImage('usbON'),
            renderPrgImage('saveBtnInActive'),
            renderPrgImage('helpBtnActive'),
            renderPrgImage('helpBtnInActive'),
            renderPrgImage('selectbar'),
            renderPrgImage('backBtn'),
            renderPrgImage('nextBtn'),

            renderPrgImage('distancesensorsActive'),
            renderPrgImage('distancesensorsInActive'),
            renderPrgImage('gesturesensorActive'),
            renderPrgImage('gesturesensorInActive'),
            renderPrgImage('lightsensorActive'),
            renderPrgImage('lightsensorInActive'),
            renderPrgImage('colorsensorActive'),
            renderPrgImage('colorsensorInActive'),
            renderPrgImage('micActive'),
            renderPrgImage('micInActive'),
            renderPrgImage('batteryActive'),
            renderPrgImage('batteryInActive'),
            renderPrgImage('tempActive'),
            renderPrgImage('tempInActive'),
            renderPrgImage('touch0Active'),
            renderPrgImage('touch0InActive'),
            renderPrgImage('touch1Active'),
            renderPrgImage('touch2Active'),
            renderPrgImage('touch3Active'),
            renderPrgImage('touch1InActive'),
            renderPrgImage('touch2InActive'),
            renderPrgImage('touch3InActive'),
            renderPrgImage('lefteyeActive'),
            renderPrgImage('lefteyeInActive'),
            renderPrgImage('righteyeActive'),
            renderPrgImage('righteyeInActive'),
            renderPrgImage('smile1Active'),
            renderPrgImage('smile1InActive'),
            renderPrgImage('smile2Active'),
            renderPrgImage('smile2InActive'),
            renderPrgImage('smile3Active'),
            renderPrgImage('smile3InActive'),
            renderPrgImage('smile4Active'),
            renderPrgImage('smile4InActive'),
            renderPrgImage('readPCActive'),
            renderPrgImage('readPCInActive'),
            renderPrgImage('buzzerActive'),
            renderPrgImage('buzzerInActive'),
            renderPrgImage('accelerometerActive'),
            renderPrgImage('accelerometerInActive'),

            renderPrgImage('devicePc'),
            renderPrgImage('PcinternalMicInActive'),
            renderPrgImage('PcinternalMicActive'),
            renderPrgImage('PcinternalBuzzerInActive'),
            renderPrgImage('PcinternalBuzzerActive'),
            renderPrgImage('PcinternalTouchpadsInActive'),
            renderPrgImage('PcinternalTouchpadsActive'),

            renderPrgImage('PcinternalEYEInActive'),
            renderPrgImage('PcinternalEYEActive'),
            renderPrgImage('PcinternalTeethActive'),
            renderPrgImage('PcinternalTeethInActive'),
            renderPrgImage('Pcinternal4in1Active'),
            renderPrgImage('Pcinternal4in1InActive'),

            renderPrgImage('popupcardType'),
            renderPrgImage('tempInActive'),
            renderPrgImage('tempActive'),

            // zing
            renderImage('activeBattery'),
            renderImage('activeUltrasonic'),
            renderImage('activeAccelerometerX'),
            renderImage('activeAccelerometerY'),
            renderImage('activeAccelerometerZ'),
            renderImage('activeGyroX'),
            renderImage('activeGyroY'),
            renderImage('activeGyroZ'),
            renderImage('activeLeftRGB'),
            renderImage('activeRightRBG'),
            renderImage('activeMp3'),
            renderImage('activeIndividual'),
            renderImage('activeActionGroup'),
            renderImage('activeHeadServo'),
            renderPrgImage('HumanoidWithPC'),

            renderCompImg('pot'),
            renderCompImg('play_shield'),
            renderCompImg('play_shield_v1_top'),
            renderCompImg('play_shield_top'),
            renderCompImg('dc_motor'),
            renderCompImg('dynamex_motor'),
            renderCompImg('geared_motor'),
            renderCompImg('mini_geared_motor'),
            renderCompImg('distance_sensor'),
            renderCompImg('dual_switch'),
            renderCompImg('joystick'),
            renderCompImg('laser'),
            renderCompImg('led'),
            renderCompImg('servo_motor'),
            renderCompImg('servo_motor_270'),
            renderCompImg('servo_motor_360'),
            renderCompImg('light_sensor'),
            renderCompImg('tact_switch'),
            renderCompImg('touch_sensor'),
            renderCompImg('ultrasonic_sensor'),
            renderCompImg('led_1c'),
            renderCompImg('tact_switch_2c'),
            renderCompImg('RGB'),
            renderCompImg('OLED'),
            renderCompImg('mp3'),
            renderCompImg('dip_switch'),
            renderCompImg('linear_pot'),
            renderCompImg('humidity'),
            renderCompImg('metal_detector'),
            renderCompImg('extender'),
            renderCompImg('temperature_sensor'),
            renderCompImg('gas'),
            renderCompImg('rain_sensor'),
            renderCompImg('pc_motor_driver'),
            renderCompImg('dual_splitter'),
            // helpScreen
            renderPrgImage('InternalPrgf1'),
            renderPrgImage('InternalPrgf2'),
            renderPrgImage('InternalPrgf3'),
            renderPrgImage('InternalPrgf4'),
            renderPrgImage('Pcv1SelectH1'),
            renderPrgImage('Pcv1SelectH2'),
            renderPrgImage('ExternalPrgf2'),
            renderPrgImage('ExternalPrgf3'),
            renderPrgImage('assemblyH'),
            renderPrgImage('Pcv1AssemblyH'),
            renderPrgImage('AssemblyPrgf1'),
            renderPrgImage('assemblyH2'),
            renderPrgImage('Pcv1AssemblyH2'),
            renderPrgImage('AssemblyPrgf2'),
            renderPrgImage('assemblyH3'),
            renderPrgImage('Pcv1AssemblyH3'),
            renderPrgImage('AssemblyPrgf3'),
            renderPrgImage('AssemblyPrgf4'),
            renderPrgImage('LogicPrgf1'),
            renderPrgImage('LogicPrgf2'),
            renderPrgImage('LogicPrgf3'),
            renderPrgImage('LogicPrgf4'),
            renderPrgImage('LogicPrgf5'),
        ]
        const onLoad = () => {
            // 'All resources loaded'
            setIsShowApplicationLoader(false)
        }

        cacheAssets(assetsToBeCached)

        //on successfull load the application we remove the loder
        if (document.readyState === 'complete') {
            onLoad()
        } else {
            window.addEventListener('load', onLoad)
            return () => window.removeEventListener('load', onLoad)
        }
    }, [])

    return (
        <>
            {isShowApplicationLoader && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'absolute',
                        height: '100vh',
                        width: '100vw',
                        background: 'rgb(0,0,0,0.3)',
                        zIndex: '1000000',
                    }}
                >
                    <div className={styles.loader}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <DialogModal {...isCondProps} />
            <DialogModal
                show={showActionModal.isShow}
                text={showActionModal.Message} //
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowActionModal({
                        isShow: false,
                        Message: '',
                        messageType: '',
                    })
                }
                optionsToSelect={dialogModelOption()}
            />
            <ViewActions
                viewPopUp={retrieveActions}
                setViewPopUp={setRetrieveActions}
            />
            <MainHeader
                help_btnPosition="right"
                helper={
                    ['Humanoid', 'Hexapod'].includes(connectedDevice) ? (
                        <div
                            className="PS-S_slide"
                            style={{
                                left: '70%',
                                transform: 'translate(-50%)',
                            }}
                        >
                            <ZingPrgmSelection />
                        </div>
                    ) : (
                        <div
                            className="PS-S_slide"
                            style={{
                                left: '70%',
                                transform: 'translate(-50%)',
                            }}
                        >
                            <PrgmSelection />
                        </div>
                    )
                }
                goBack={() => {
                    setSlideDirection(true)
                    sessionStorage.setItem('slideDirection', true)
                    history.push('/code')
                }}
                isGoBack={true}
            />
            <img
                alt=""
                src={renderPrgImage('programmenucard')}
                style={{
                    position: 'absolute',
                    top: '8.5%',
                    left: '12%',
                    transform: 'translate(-50%,-50%)',
                    height: '22%',
                }}
            />
            <p
                style={{
                    position: 'absolute',
                    top: '7%',
                    left: '11.5%',
                    transform: 'translate(-50%,-50%)',
                    color: 'white',
                    fontSize: '18px',
                }}
            >
                {languageWords[props.languageName]?.Code || 'Code'}
            </p>

            <div style={{ height: '80%', position: 'relative' }}>
                {' '}
                <div style={container}>
                    {MENU_OPTIONS &&
                        MENU_OPTIONS.map((option, index) => (
                            <div
                                key={index}
                                style={
                                    ['Klaw'].includes(connectedDevice) &&
                                    ['OpenAction', 'NewAction'].includes(
                                        option.name
                                    )
                                        ? {
                                              width: '19rem',
                                              height: '15rem',
                                              //   opacity: 0.3,
                                              position: 'relative',
                                          }
                                        : {
                                              width: '19rem',
                                              height: '15rem',
                                              position: 'relative',
                                          }
                                }
                            >
                                {option.name === 'OpenProject' ||
                                option.name === 'OpenAction' ? (
                                    <>
                                        <img
                                            alt=""
                                            src={renderPrgImage(option.imgSrc)}
                                            style={{
                                                ...option.imgStyle,
                                                opacity: '1',
                                                // option.name ===
                                                //     'OpenAction' &&
                                                // [
                                                //     'Hexapod',
                                                //     'Humanoid',
                                                // ].includes(
                                                //     connectedDevice
                                                // ) &&
                                                // ['1'].includes(
                                                //     deviceVersion[0]
                                                // )
                                                //     ? '0.5'
                                                //     : '1',
                                            }}
                                        />
                                        <p
                                            style={{
                                                ...menuText,
                                                opacity: '1',
                                                // option.name ===
                                                //     'OpenAction' &&
                                                // [
                                                //     'Hexapod',
                                                //     'Humanoid',
                                                // ].includes(
                                                //     connectedDevice
                                                // ) &&
                                                // ['1'].includes(
                                                //     deviceVersion[0]
                                                // )
                                                //     ? '0.5'
                                                //     : '1',
                                            }}
                                        >
                                            {
                                                languageWords[
                                                    props.languageName
                                                ]?.[option.name]
                                            }
                                        </p>
                                        <div
                                            style={{
                                                width: '50%',
                                                height: '54%',
                                                position: 'relative',
                                                top: '-16rem',
                                                left: '5rem',
                                                cursor: 'pointer',
                                                // option.name ===
                                                //     'OpenAction' &&
                                                // [
                                                //     'Hexapod',
                                                //     'Humanoid',
                                                // ].includes(
                                                //     connectedDevice
                                                // ) &&
                                                // ['1'].includes(
                                                //     deviceVersion[0]
                                                // )
                                                //     ? 'default'
                                                //     : 'pointer',
                                            }}
                                            onClick={() => {
                                                beforeOpenFileHandel(
                                                    option,
                                                    index
                                                )
                                            }}
                                        ></div>
                                        {
                                            <input
                                                id={`file-input-${index}`}
                                                type="file"
                                                accept=".pld"
                                                hidden
                                                onInput={(event) => {
                                                    openProject(
                                                        event,
                                                        option.name,
                                                        option.link
                                                    )
                                                }}
                                            />
                                        }

                                        {/* ---------------- folder input folder-input-3------------------ */}
                                        {['2', '3'].includes(
                                            deviceVersion?.[0]
                                        ) &&
                                            option.name === 'OpenAction' && (
                                                <input
                                                    id={`folder-input-${index}`}
                                                    type="file"
                                                    webkitdirectory="true"
                                                    directory="true"
                                                    multiple
                                                    // onChange={
                                                    //     handleFolderUpload
                                                    // }
                                                    hidden
                                                    onInput={(event) => {
                                                        handleFolderUpload(
                                                            event,
                                                            option.name,
                                                            option.link
                                                        )
                                                    }}
                                                />
                                            )}
                                    </>
                                ) : (
                                    <>
                                        <img
                                            alt=""
                                            src={renderPrgImage(option.imgSrc)}
                                            style={{
                                                ...option.imgStyle,
                                                opacity: '1',
                                                // option.name ===
                                                //     'NewAction' &&
                                                // [
                                                //     'Hexapod',
                                                //     'Humanoid',
                                                // ].includes(
                                                //     connectedDevice
                                                // ) &&
                                                // ['1'].includes(
                                                //     deviceVersion[0]
                                                // )
                                                //     ? '0.5'
                                                //     : '1',
                                            }}
                                        />
                                        <p
                                            style={{
                                                ...menuText,
                                                opacity: '1',
                                                // option.name ===
                                                //     'NewAction' &&
                                                // [
                                                //     'Hexapod',
                                                //     'Humanoid',
                                                // ].includes(
                                                //     connectedDevice
                                                // ) &&
                                                // ['1'].includes(
                                                //     deviceVersion[0]
                                                // )
                                                //     ? '0.5'
                                                //     : '1',
                                            }}
                                            onClick={() => {
                                                beforeHandelNewFile(option)
                                            }}
                                        >
                                            {
                                                languageWords[
                                                    props.languageName
                                                ]?.[option.name]
                                            }
                                        </p>
                                        <div
                                            style={{
                                                width: '50%',
                                                height: '54%',
                                                position: 'relative',
                                                top: '-16rem',
                                                left: '5rem',
                                                cursor: 'pointer',
                                                // option.name ===
                                                //     'NewAction' &&
                                                // [
                                                //     'Hexapod',
                                                //     'Humanoid',
                                                // ].includes(
                                                //     connectedDevice
                                                // ) &&
                                                // ['1'].includes(
                                                //     deviceVersion[0]
                                                // )
                                                //     ? 'default'
                                                //     : 'pointer',
                                            }}
                                            onClick={() => {
                                                beforeHandelNewFile(option)
                                            }}
                                        ></div>
                                    </>
                                )}
                            </div>
                        ))}
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    // return state;
    return {
        device: state.device,
        webSerial: state.webSerial,
        languageName: state.device.language,
        worker: state.worker,
        socketData: state.socketData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        selecteComponent: (data) => {
            dispatch({ type: 'COMPONENT', payload: data })
        },
        selecteInternalAcessories: (data) => {
            dispatch({ type: 'INTERNAL_ACCESSORIES', payload: data })
        },

        assemblyComponent: (data) => {
            dispatch({ type: 'ASSEMBLY', payload: data })
        },
        logicComponent: (data) => {
            dispatch({ type: 'LOGIC_RESET', payload: data })
        },
        setZingMp3List: (data) => {
            dispatch({ type: 'ZING_MP3_LIST', payload: data })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Project)
